import { supabase } from "@/integrations/supabase/client";

export type CoverageGrain = "year" | "quarter" | "month";

export interface CoverageStateSummary {
  state: string;
  sales: number;
  sqm: number | null;
  crawl: number | null;
  regions: number;
  first_month: string;
  last_month: string;
  last_sqm_month: string | null;
  last_crawl_month: string | null;
}

export interface CoverageCell {
  region: string;
  period: string;
  sqm: number;
  crawl: number;
}

export interface DataCoverage {
  refreshedAt: string | null;
  state: string;
  grain: CoverageGrain;
  states: CoverageStateSummary[];
  cells: CoverageCell[];
}

/** Sales per region and period for one state, from the daily data_coverage_monthly view. */
export async function fetchDataCoverage(
  state: string,
  grain: CoverageGrain,
): Promise<DataCoverage> {
  // data_coverage is newer than the generated Supabase types.
  const { data, error } = await (supabase as any).rpc("data_coverage", {
    p_state: state,
    p_grain: grain,
  });
  if (error) throw error;
  return data as DataCoverage;
}
